var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ds-loader' ].concat( _vm.loaderWrapperClasses),style:({ backgroundColor: _vm.backgroundColor, height: _vm.height, maxHeight: _vm.maxHeight, transform: _vm.transform })},[_c('div',{class:[].concat( _vm.loaderClasses )})])}
var staticRenderFns = []

export { render, staticRenderFns }